<template>
	<panel ref="panelRef" :show="show" class="schedule-section" @close="close">
		<template #title>
			Office Open Hours Schedule
		</template>
		<template>
			<div class="schedule-section-content">
				<div class="card">
					<div class="card-title header">
						<div></div>
						<div>
							office hours
						</div>
						<div>
							lunch hours
						</div>
					</div>
					<div class="card-body">
						<div class="card-row header">
							<div>
								<div class="card-cell header">
									day
								</div>
								<div class="card-cell header">
									open/closed
								</div>
							</div>
							<div>
								<div class="card-cell header">
									start
								</div>
								<div class="card-cell header">
									end
								</div>
							</div>
							<div>
								<div class="card-cell header">
									start
								</div>
								<div class="card-cell header">
									end
								</div>
							</div>
						</div>
						<div
							v-for="(day, index) in officeHours"
							:key="day.day_name"
							class="card-row"
						>
							<div>
								<div class="card-cell">{{ day.day_name }}</div>
								<div class="card-cell">
									<label class="switch">
										<input
											type="checkbox"
											:checked="day.is_open"
											@change="
												updateOpenStatus(
													index,
													$event.target.checked
												)
											"
										/>
										<span
											class="slider"
											:class="{
												close: !day.is_open,
											}"
										>
											{{
												day.is_open ? 'Open' : 'Closed'
											}}
										</span>
									</label>
								</div>
							</div>
							<div>
								<div class="card-cell">
									<input
										v-if="
											day.starts_at !== null ||
												day.is_open
										"
										:value="day.starts_at"
										type="time"
										:name="`${day.day_name}_starts_at`"
										class="form-input"
										:disabled="!day.is_open"
										placeholder="Office Start Time"
										@input="
											updateField(
												day.day_name,
												'starts_at',
												$event.target.value
											)
										"
									/>

									<div v-else class="form-input-empty">
										{{ '-' }}
									</div>
								</div>
								<div class="card-cell">
									<input
										v-if="
											day.ends_at !== null || day.is_open
										"
										:value="day.ends_at"
										type="time"
										:name="`${day.day_name}_ends_at`"
										class="form-input"
										:disabled="!day.is_open"
										placeholder="Office End Time"
										@input="
											updateField(
												day.day_name,
												'ends_at',
												$event.target.value
											)
										"
										@blur="
											if (day.ends_at === '00:00') {
												updateField(
													day.day_name,
													'ends_at',
													'23:59'
												)
											}
										"
									/>
									<div v-else class="form-input-empty">
										{{ '-' }}
									</div>
								</div>
							</div>
							<div>
								<div class="card-cell">
									<input
										v-if="
											day.lunch_starts_at !== null ||
												day.is_open
										"
										:value="day.lunch_starts_at"
										type="time"
										:name="
											`${day.day_name}_lunch_starts_at`
										"
										class="form-input"
										:disabled="!day.is_open"
										placeholder="Lunch Start Time"
										@input="
											updateField(
												day.day_name,
												'lunch_starts_at',
												$event.target.value
											)
										"
									/>

									<div v-else class="form-input-empty">
										{{ '-' }}
									</div>
								</div>
								<div class="card-cell">
									<input
										v-if="
											day.lunch_ends_at !== null ||
												day.is_open
										"
										:value="day.lunch_ends_at"
										type="time"
										:name="`${day.day_name}_lunch_ends_at`"
										class="form-input"
										:disabled="!day.is_open"
										placeholder="Lunch End Time"
										@input="
											updateField(
												day.day_name,
												'lunch_ends_at',
												$event.target.value
											)
										"
										@blur="
											if (day.lunch_ends_at === '00:00') {
												updateField(
													day.day_name,
													'lunch_ends_at',
													'23:59'
												)
											}
										"
									/>
									<div v-else class="form-input-empty">
										{{ '-' }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					v-if="disableSavebtn && !isFetchingOfficeHours"
					class="error-message"
				>
					<span class="error-message-text">{{
						emptyScheduleErrorMessage
					}}</span>
				</div>
				<div class="form-group form-button">
					<button
						class="action-button"
						:disabled="busy || disableSavebtn"
						@keydown.tab="onLastElementTab"
						@click="!disableSavebtn && officeHoursSubmit()"
					>
						<span class="btn-label">
							Save
						</span>
					</button>
				</div>
			</div>
		</template>

		<template>
			<!-- Popup Warning -->
			<div v-if="popupBox" class="schedule-popup-overlay">
				<div class="schedule-popup">
					<div class="popup-body">
						<span>Exit without Saving ?</span>
					</div>
					<div class="popup-footer">
						<button
							class="popup-button"
							@click.prevent="onCancelClick"
						>
							<span class="btn-text">Cancel</span>
						</button>
						<button
							class="popup-button"
							@click.prevent="onExitClick"
						>
							<span class="btn-text">Exit</span>
						</button>
						<button
							class="popup-button"
							:class="{ 'popup-button-disabled': disableSavebtn }"
							:disabled="disableSavebtn"
							@click.prevent="
								!disableSavebtn && officeHoursSubmit()
							"
						>
							<span class="btn-text">Save</span>
						</button>
					</div>
				</div>
			</div>
		</template>
	</panel>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Panel from './Panel'
import _ from 'lodash'
import {
	DEFAULT_OFFICE_TIMINGS,
	OFFICE_DAYS,
	EMPTY_SCHEDULE_ERROR_MESSAGE,
} from '@/config/constants'
import util from '@/util'

export default {
	components: {
		Panel,
	},
	computed: {
		isIVRExist() {
			return this.partner?.ivr_exists
		},

		scheduleIsEmpty() {
			const isTimeEmpty = v => v == null || v === ''
			const isEveryClosed = this.officeHours.every(day => !day.is_open)
			const isEveryTimeEmpty = this.officeHours.every(
				day =>
					isTimeEmpty(day.starts_at) &&
					isTimeEmpty(day.ends_at) &&
					isTimeEmpty(day.lunch_starts_at) &&
					isTimeEmpty(day.lunch_ends_at)
			)
			return isEveryClosed && isEveryTimeEmpty
		},

		disableSavebtn() {
			return this.isIVRExist && this.scheduleIsEmpty
		},

		...mapGetters({ partner: 'partners/active' }),
	},

	methods: {
		async fetchOfficeHours() {
			try {
				this.isFetchingOfficeHours = true
				const response = await this.$api
					.partners(this.partner.id)
					.schedules()
					.get()

				const apiData = response.get('data', [])

				this.updateOfficeHoursFromAPI(apiData)
			} catch (e) {
				this.$alert.error(e)
			} finally {
				this.isFetchingOfficeHours = false
			}
		},

		showPopup() {
			this.popupBox = true
		},
		hidePopup() {
			this.popupBox = false
		},

		updateOpenStatus(index, isChecked) {
			this.$set(this.officeHours[index], 'is_open', isChecked)

			if (isChecked) {
				const defaults = DEFAULT_OFFICE_TIMINGS
				const timing = this.officeHours[index]
				const keys = Object.keys(defaults)
				const hasAllEmpty = keys.every(key => !timing[key])

				if (hasAllEmpty) {
					for (const [key, defaultValue] of Object.entries(
						defaults
					)) {
						if (!this.officeHours[index][key]) {
							this.$set(
								this.officeHours[index],
								key,
								defaultValue
							)
						}
					}
				}
			}
		},

		updateField(dayName, field, value) {
			const dayIndex = this.officeHours.findIndex(
				d => d.day_name === dayName
			)
			if (dayIndex !== -1) {
				return this.$set(this.officeHours[dayIndex], field, value)
			}
		},

		updateOfficeHoursFromAPI(apiData) {
			this.officeHours = this.officeHours.map(localDay => {
				const apiDay = apiData.find(
					d =>
						d.day_name.toLowerCase() ===
						localDay.day_name.toLowerCase()
				)
				return apiDay
					? { ...localDay, ...apiDay, day_name: localDay.day_name }
					: localDay
			})

			this.extracted = this.extractedProperties(this.officeHours)
		},

		extractedProperties(arr) {
			return arr.map(
				({
					starts_at,
					ends_at,
					lunch_starts_at,
					lunch_ends_at,
					day_name,
					is_open,
				}) => ({
					starts_at: starts_at ?? null,
					ends_at: ends_at ?? null,
					lunch_starts_at: lunch_starts_at ?? null,
					lunch_ends_at: lunch_ends_at ?? null,
					day_name: day_name ?? null,
					is_open: is_open ?? false,
				})
			)
		},

		isOfficeHoursNotChanged(arr1, arr2) {
			const x = this.extractedProperties(arr1)
			const i = this.extractedProperties(arr2)
			const y = x.map(day => ({
				...day,
				day_name: day.day_name.toLowerCase(),
			}))
			const z = i.map(day => ({
				...day,
				day_name: day.day_name.toLowerCase(),
			}))
			const a = _.sortBy(y, ['day_name'])
			const b = _.sortBy(z, ['day_name'])
			return _.isEqual(a, b)
		},

		normalizeOfficeDay(day) {
			return {
				...day,
				day_name: day.day_name.toLowerCase(),
				is_open: day.is_open ?? false,
				starts_at: day.starts_at ? day.starts_at : null,
				lunch_starts_at: day.lunch_starts_at
					? day.lunch_starts_at
					: null,
				lunch_ends_at: day.lunch_ends_at ? day.lunch_ends_at : null,
				ends_at: day.ends_at ? day.ends_at : null,
			}
		},

		getModifiedPayload() {
			return this.officeHours.map(day => this.normalizeOfficeDay(day))
		},

		daynameToLowerCase() {
			return this.officeHours?.map(d => ({
				...d,
				day_name: d.day_name.toLowerCase(),
			}))
		},

		async officeHoursSubmit() {
			try {
				this.busy = true
				// Convert day names to lowercase before sending
				const payload = this.daynameToLowerCase()

				for (let day of payload) {
					if (day?.is_open) {
						if (!day.starts_at && !day.ends_at) {
							this.$alert.error(
								'Office start and end times are required.'
							)
							return
						}

						if (
							Boolean(day.starts_at) !== Boolean(day.ends_at) ||
							day.starts_at > day.ends_at
						) {
							this.$alert.error('Please enter a valid time.')
							return
						}

						if (
							Boolean(day.lunch_starts_at) !==
								Boolean(day.lunch_ends_at) ||
							day.lunch_starts_at > day.lunch_ends_at
						) {
							this.$alert.error('Please enter a valid time.')
							return
						}

						if (day.lunch_starts_at && day.lunch_ends_at) {
							if (
								day.lunch_starts_at < day.starts_at ||
								day.lunch_ends_at > day.ends_at
							) {
								this.$alert.error(
									'Lunch time must be within office hours.'
								)
								return
							}
						}

						if (day.starts_at && day.ends_at) {
							if (day.starts_at === day.ends_at) {
								this.$alert.error(
									'Office start and end times cannot be the same.'
								)
								return
							}
						}

						if (day.lunch_starts_at && day.lunch_ends_at) {
							if (day.lunch_starts_at === day.lunch_ends_at) {
								this.$alert.error(
									'Lunch start and end times cannot be the same.'
								)
								return
							}
						}
					}
				}

				const perfectPayload = this.getModifiedPayload()

				const response = await this.$api
					.partners(this.partner.id)
					.schedules()
					.create(perfectPayload)

				const data = response.get('data', [])

				await this.getOfficestatus(data)

				this.officeHours = data.map(day => ({
					...day,
					day_name: util.capitalizeFirstLetter(day.day_name),
				}))

				this.$alert.success(
					response?.response?.message ||
						'Office hours saved successfully.'
				)

				this.hidePopup()
				this.closePanel()
			} catch (e) {
				this.$alert.error(
					e?.response?.errors?.schedules?.[0] ||
						e?.response?.message ||
						e?.message
				)
			} finally {
				this.busy = false
			}
		},

		...mapActions('settings', {
			getOfficestatus: 'getOfficestatus',
		}),

		close() {
			if (
				this.isOfficeHoursNotChanged(this.officeHours, this.extracted)
			) {
				this.closePanel()
			} else {
				this.showPopup()
			}
		},

		onExitClick() {
			this.hidePopup() // Hide the popup
			this.closePanel() // Close the sidebar
		},

		onCancelClick() {
			this.hidePopup()
		},

		closePanel() {
			this.$emit('close')

			this.hasFetchedOfficeHours = false
			this.clearOfficeHours()
		},

		clearOfficeHours() {
			this.officeHours = OFFICE_DAYS.map(i => ({
				day_name: i,
				starts_at: null,
				ends_at: null,
				is_open: false,
				lunch_starts_at: null,
				lunch_ends_at: null,
			}))
		},
	},
	name: 'SchedulePanel',
	props: {
		show: {
			type: Boolean,
			required: true,
		},
	},

	watch: {
		async show() {
			if (this.show) {
				this.isFetchingOfficeHours = true
				await this.fetchOfficeHours()
			}
		},
	},
	data() {
		return {
			officeHours: OFFICE_DAYS.map(i => ({
				day_name: i,
				starts_at: null,
				ends_at: null,
				is_open: false,
				lunch_starts_at: null,
				lunch_ends_at: null,
			})),
			busy: false,
			extracted: [],
			popupBox: false,
			isFetchingOfficeHours: false,
			emptyScheduleErrorMessage: EMPTY_SCHEDULE_ERROR_MESSAGE,
		}
	},
}
</script>
